<!--
 * @Author:
 * @Description:
 * @Date: 2025-03-31 15:16:35
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/App.vue
-->
<template>
  <div id="app" ref="appRef">
    <router-view />
    <GlobalModal v-if="isShowModal&&shouldShowModal" @close="closeModal" />
    <!-- <div style="position: fixed;width: 100px;height: 100px;top: 50%;left: 50%;background-color: red;"></div> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

// 导入语言设置工具函数
import GlobalModal from '@/components/globalModal/index.vue';
import { setI18nLanguage } from '@/language';
// 导入埋点管理工具
import { eventTrackManager } from '@/plugins/eventTrackManager';
// 导入路由状态管理相关常量
import { ROUTE_SET, ROUTE_FROM_SET } from '@/store/modules/route';
// 导入Cookie管理工具
import PacypayCookie from '@/utils/cookie-consent/cookie';
// 导入全局弹窗组件
export default {
  components: {
    GlobalModal,
  },
  data() {
    return {
      isLoginPage: false,
      isShowModal: false,
    };
  },
  // 组件挂载后的生命周期钩子
  computed: {
    ...mapGetters([
      'app',
    ]),
    shouldShowModal() {
      // 当前路由路径
      if (this.$route.path !== '/user/login' && this.app.businessTypes.showNovationPopup) {
        return true;
      } else {
        return false;
      }
      // 判断条件
    },
  },
  created() {

  },
  methods: {
    closeModal() {
      this.isShowModal = false;
    },
  },
  // eslint-disable-next-line space-before-function-paren
  mounted() {
    this.isShowModal = false;
    console.log('appvue', this.app.businessTypes);
    // 初始化埋点管理器：传入Vuex store和i18n实例，用于后续埋点数据收集
    eventTrackManager.init(this.$store, this.$i18n);
    const saveLang = window.localStorage.getItem('lang');
    const lang = saveLang && saveLang !== 'null' ? saveLang : 'en';// (navigator.language || navigator.browserLanguage).toLowerCase();
    // 初始化语言和Cookie政策URL变量
    let locale = 'en';
    let cookiePolicyUrl = '/static/files/cookie.html';
    // 根据语言设置配置i18n和Cookie政策URL
    if (lang.indexOf('zh') >= 0) {
      setI18nLanguage('zh-cn', this.$i18n);
      locale = 'zh-cn';
      cookiePolicyUrl = '/static/files/cookie-zh.html';
    } else if (lang.indexOf('en') >= 0) {
      setI18nLanguage('en', this.$i18n);
    } else {
      setI18nLanguage('en', this.$i18n);
    }
    // 根据屏幕宽度设置rem基准值
    if (window.screen.width > 992) {
      document.documentElement.style = 'font-size: 50px';
      document.body.style.fontSize = '16px';
    } else {
      require('lib-flexible');
    }
    // 初始化Cookie管理实例
    // eslint-disable-next-line no-new
    window.pCookie = new PacypayCookie({
      policyUrl: cookiePolicyUrl,
      locale,
    });
    // 全局弹窗组件
  },
  // 监听路由变化
  watch: {
    $route: function(to, from) {
      // 更新路由状态
      this.$store.commit(ROUTE_SET, {
        value: to,
        time: new Date().getTime(),
      });

      this.$store.commit(ROUTE_FROM_SET, from);
      if (to.path !== from.path) {
        this.isShowModal = true;
        eventTrackManager.send({
          e: 'view_page',
        });
      }
      // console.log('to.path', to.path, 'from.path', from.path);
    },
  },
};
</script>
<style>
@import './utils/cookie-consent/cookie.css';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  list-style: none;
}
</style>
